import { useState } from "react";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export default function ComingSoon({ title, message }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/waitlist", { email: email.trim() });
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-mint-ink text-white flex flex-col items-center justify-center px-6 py-16 text-center relative overflow-hidden" data-testid="coming-soon-page">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-mint/20 blur-3xl" aria-hidden="true" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-mint/10 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-xl w-full">
        <div className="flex items-center justify-center gap-2 mb-8">
          <img src="/logo.png" alt="" className="h-9 w-auto" />
          <span className="font-extrabold text-2xl">Washly</span>
        </div>
        <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-1.5 text-sm font-semibold mb-6">
          <Sparkles size={16} aria-hidden="true" /> Launch steht bevor
        </div>
        <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 leading-tight" data-testid="coming-soon-title">{title}</h1>
        <p className="text-lg text-white/80 mb-10" data-testid="coming-soon-message">{message}</p>

        {done ? (
          <div className="bg-white/10 rounded-2xl p-6 flex items-center justify-center gap-3" data-testid="coming-soon-success">
            <CheckCircle2 size={22} aria-hidden="true" />
            <span className="font-semibold">Danke! Wir melden uns bei dir zum Start.</span>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="coming-soon-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Deine E-Mail-Adresse"
              className="flex-1 rounded-full px-5 py-3 text-ink bg-white placeholder:text-ink-2 focus:outline-none focus:ring-2 focus:ring-mint"
              data-testid="coming-soon-email"
            />
            <button
              type="submit"
              disabled={busy}
              className="rounded-full px-6 py-3 bg-mint text-mint-ink font-bold hover:bg-mint-hover transition-colors disabled:opacity-60"
              data-testid="coming-soon-submit"
            >
              {busy ? "..." : "Benachrichtige mich"}
            </button>
          </form>
        )}
        <p className="text-sm text-white/60 mt-8">© {new Date().getFullYear()} Washly</p>
      </div>
    </div>
  );
}
